import React, {useEffect, useState} from 'react';
import {CurrentDrawnRectangle, Rectangle} from "./interfaces";

interface PageProperties {
    selectedRectangle: Rectangle | null,
    setSelectedRectangle: React.Dispatch<React.SetStateAction<Rectangle | null>>,
    mode: "blacken" | "highlight",

    rectangles: Rectangle[],
    setRectangles: React.Dispatch<React.SetStateAction<Rectangle[]>>,
    removeSelectedRectangle: Function,
    demoPage: boolean
}

function Page({selectedRectangle, setSelectedRectangle, mode, rectangles, setRectangles, removeSelectedRectangle, demoPage}: PageProperties) {
    const [currentDrawnRect, setCurrentDrawnRect] = useState<CurrentDrawnRectangle | null>(null)

    useEffect(() => {
        const listener = (e: KeyboardEvent) => {
            if (e === undefined || e === null) {
                return;
            }
           if (e.key === "Escape" && currentDrawnRect != null) {
                setCurrentDrawnRect(null);
            }
        };
        document.addEventListener("keydown", listener)
        return () => document.removeEventListener("keydown", listener);
    }, [currentDrawnRect]);

    const calculateRectSizing = (rect: CurrentDrawnRectangle | null, event: React.MouseEvent<HTMLImageElement, MouseEvent>): CurrentDrawnRectangle => {
        let canvas = event.currentTarget;
        let x = event.pageX - canvas.getBoundingClientRect().x - window.scrollX;
        let y = event.pageY - canvas.getBoundingClientRect().y - window.scrollY;
        x = Math.ceil(x);
        y = Math.ceil(y);

        //start of new rect
        if (rect === null) {
            return {
                x: x,
                y: y,
                startX: x,
                startY: y,
                width: 0,
                height: 0,
                mode: mode
            }
        } else {
            return {
                startX: rect.startX,
                startY: rect.startY,
                x: (x < rect.startX) ? x : rect.startX,
                y: (y < rect.startY) ? y : rect.startY,
                width: Math.abs(x - rect.startX),
                height: Math.abs(y - rect.startY),
                mode: mode
            };
        }
    }

    function canvasDragStart(event: React.MouseEvent<HTMLImageElement, MouseEvent>) {
        //drag: start with a rectangle; it will be finished on dragend (="click", as click is the complete)
        event.preventDefault()
        setSelectedRectangle(null);

        if (currentDrawnRect === null) {
            let resultingRect = calculateRectSizing(currentDrawnRect, event);
            setCurrentDrawnRect(resultingRect)
        }
    }

    function canvasClick(event: React.MouseEvent<HTMLImageElement, MouseEvent>) {
        //if a rectangle is selected, deselect. otherwise, draw
        if (selectedRectangle !== null) {
            setSelectedRectangle(null);
            return;
        }

        if (currentDrawnRect === null) {
            let resultingRect = calculateRectSizing(currentDrawnRect, event);
            setCurrentDrawnRect(resultingRect)
        }
        //finish existing rect
        else {
            let resultingRect = calculateRectSizing(currentDrawnRect, event);
            console.log(resultingRect, rectangles)
            setRectangles([...rectangles, resultingRect]);
            setCurrentDrawnRect(null);
        }
    }


    function canvasMove(event: React.MouseEvent<HTMLImageElement, MouseEvent>) {
        let resultingRect = calculateRectSizing(currentDrawnRect, event);
        if (currentDrawnRect !== null) {
            setCurrentDrawnRect(resultingRect);
        }
    }

    function rectangleClick(rect: Rectangle) {
        console.log("rectangle click")
        setSelectedRectangle(rect);
    }

    useEffect(() => {
        console.log("rectangles update ", rectangles)
    }, [rectangles]);

    return (
        <div className={"my-2 singlePage"}>
            <div className={`canvasOverlay ${currentDrawnRect ? 'currentlyBeingDrawn' : ''}`}>
                {currentDrawnRect !== null && (
                    <div className={"currentDrawnRectangle " + currentDrawnRect.mode} style={{
                        left: currentDrawnRect.x,
                        top: currentDrawnRect.y,
                        width: currentDrawnRect.width,
                        height: currentDrawnRect.height
                    }}></div>
                )}
                {rectangles.map((rectangle) =>
                    <div
                        key={rectangles.indexOf(rectangle)}
                        className={"finishedRectangle " + (rectangle === selectedRectangle ? "selectedRectangle" : "") + " " + rectangle.mode}
                        style={{
                            left: rectangle.x,
                            top: rectangle.y,
                            width: rectangle.width,
                            height: rectangle.height
                        }} onClick={() => rectangleClick(rectangle)}>
                        {(rectangle === selectedRectangle) && (
                            <button type="button" className="btn-close deleteRectangleButton bg-light bg-opacity-50" aria-label="Close" onClick={() => removeSelectedRectangle()}></button>
                        )}
                    </div>
                )}
            </div>
            {demoPage && (
                <div className={"demoPage d-flex justify-content-center "}>
                    <div className={"align-self-center text-center"}>
                        <p className={"fs-2 text-light"}>In der Web-Version nur für die <br/>ersten beiden Seiten
                            verfügbar.</p>
                        <p><a className={"btn btn-secondary btn-lg"} href={"https://www.netzbeweis.com/kontakt/"}>Demo
                            anfordern</a>
                        </p>
                    </div>
                </div>
            )}
            <img alt={"page"} className={"drawCanvas"} onClick={canvasClick} onMouseMove={canvasMove} onDragStart={canvasDragStart}></img></div>)
}

export default Page;